/**
 * Owned Media: supportIA del costado en modo OML mientras el apartado está
 * montado (08/10/2026). Mismo mecanismo que Partnerships y TA (PageContext).
 */
import { useEffect } from 'react';
import { usePageContext } from '@/contexts/PageContext';

export function useRegisterOmlContext(enabled: boolean) {
  const { setOmlCtx } = usePageContext();
  useEffect(() => {
    if (!enabled) return;
    setOmlCtx({ section: 'owned-media' });
    return () => setOmlCtx(null);
  }, [setOmlCtx, enabled]);
}
